import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-[40%]">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                <span className="text-primary-500">韩漫</span>
                <span className="text-foreground-950">网址</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-sm">
              免费韩漫大全资源导航站，为您提供便捷的韩漫在线阅读入口。简化寻找优质韩漫内容的过程，让阅读更简单。
            </p>
            <div className="space-y-3">
              <p className="text-xs text-foreground-600 font-medium">订阅韩漫更新资讯</p>
              <form className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱地址"
                  className="flex-1 bg-transparent border-b border-foreground-300 px-2 py-2 text-sm text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-6 py-2 border border-foreground-300 rounded-full text-sm text-foreground-700 hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-8">
            <div>
              <p className="text-sm font-semibold text-foreground-950 mb-4">分类导航</p>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-950 mb-4">更多分类</p>
              <div className="flex flex-col gap-2.5">
                {categories.slice(4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-950 mb-4">关于我们</p>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">品牌介绍</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">联系方式</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">用户口碑</Link>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩国漫画网 - 免费韩漫大全资源导航站。本站为导航性质，不存储任何漫画内容。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}